import React, { useState, useRef, useEffect } from 'react';
import '../CSS/Navbar.css';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

// Function to delete a cookie by name
const deleteCookie = (cookieName) => {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

function MainNavbar({ handleLogout }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [organizationInfo, setOrganizationInfo] = useState(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userSession = Cookies.get('userSession');
    if (userSession) {
      const parsedSession = JSON.parse(userSession);
      const organizationInfo = parsedSession?.data?.organization_info;
      if (organizationInfo) {
        setOrganizationInfo({
          name: organizationInfo.name || 'No Organization',
          code: organizationInfo.organizations_code || 'No Code',
          panCard: organizationInfo.pancard_no || 'No PAN Card',
        });
      }
    }

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);  // Effect only runs once, on initial mount

  // Function to check and update organization info
  const checkOrganizationInfo = () => {
    const userSession = Cookies.get('userSession');
    if (userSession) {
      const parsedSession = JSON.parse(userSession);
      const organizationInfo = parsedSession?.data?.organization_info;
      if (organizationInfo) {
        setOrganizationInfo({
          name: organizationInfo.name || 'No Organization',
          code: organizationInfo.organizations_code || 'No Code',
          panCard: organizationInfo.pancard_no || 'No PAN Card',
        });
      }
    }
  };

 const userSession = Cookies.get('userSession');

 useEffect(() => {
  checkOrganizationInfo();
  }, [userSession]);
  const toggleDropdown = (event) => {
    event.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogoutClick = () => {
    // Remove user session and organization details cookies
    deleteCookie('userSession');
    deleteCookie('organizationDetails');  // Make sure this matches your actual cookie name
    
    // Optionally clear any other relevant local storage items
    localStorage.removeItem('loggedIn');
    localStorage.removeItem('currentPage');
    
    // Debugging log to confirm deletion
    console.log('User logged out. Cookies and localStorage cleared.');
    
    // Call the parent logout handler
    handleLogout();
    
    // Redirect to the home page or login page
    navigate('/');
    window.location.reload();
  };

  return (
    <nav className="navbar">
      <h1 className="navbar-logo" onClick={() => navigate('/dashboard')}>
        X Vector Technologies Pvt. Ltd.
      </h1>
      <div className="user-tab" onClick={toggleDropdown} ref={dropdownRef}>
        <i className="fas fa-user user-icon"></i>
        <span className="user-name">{organizationInfo?.name || 'Admin'}</span>

        {dropdownOpen && (
          <div className="dropdown">
            {organizationInfo && (
              <>
                <p><strong>Organization :</strong> {organizationInfo.name}</p>
                <p><strong>Organization Code :</strong> {organizationInfo.code}</p>
                <p><strong>PAN Card No. :</strong> {organizationInfo.panCard}</p>
              </>
            )}
            <button className="logout-btn" onClick={handleLogoutClick}>
              <i className="fas fa-sign-out-alt"></i> Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}

export default MainNavbar;
